import HttpService from '../../../core/rest/http.service';
export async function loadActions(filter) {
    let parameters = {};
    parameters = {
        q: filter.query,
        actionType: filter.actionTypeId || undefined,
        actionTypeSlug: filter.actionTypeSlug || undefined,
        fromDate: filter.dateFrom || undefined,
        toDate: filter.dateTo || undefined,
        dateRange: filter.dateRange || undefined,
        groupId: filter.groupId,
        showSiteUrl: filter.showSiteUrl,
        page: filter.pager.page,
        pageSize: filter.pager.perPage,
        order: ['datumOd']
    };
    Object.entries(parameters).forEach(([key, value]) => {
        if (value === undefined)
            delete parameters[key];
    });
    const endpoint = "/search/mc/akce";
    return HttpService.get(endpoint, parameters);
}
export async function loadCategories(vocabularyGroupId) {
    let parameters = {};
    parameters = {
        groupId: vocabularyGroupId || undefined,
    };
    Object.entries(parameters).forEach(([key, value]) => {
        if (value === undefined)
            delete parameters[key];
    });
    const endpoint = "/search/mc/akce/kategorie";
    return HttpService.get(endpoint, parameters);
}
